import React, { Component } from 'react';

class TemporaryUnavailable extends Component {
  render() {
    return (
      <div className="valign-wrapper" style={{ height: '100vh', justifyContent: 'center' }}>
        <div className="valign" style={{ maxWidth: '600px' }}>
          <div className="container maincontainer">
            <div className="section">
              <h4>Website is temporarily unavailable</h4>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TemporaryUnavailable;
